// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"383042a0","236":"9e4eb59b","295":"c0522264","824":"b63c52db","894":"66d0ebca"}[chunkId] + ".chunk.css";
};